$(document).ready(function () {

  function calculateDeliveryDate(daysToAdd) {
    const currentDate = new Date();
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const addBusinessDays = (startDate, numDays) => {
      const resultDate = new Date(startDate);
      let addedDays = 0;
      while (addedDays < numDays) {
        resultDate.setDate(resultDate.getDate() + 1);
        if (resultDate.getDay() !== 0 && resultDate.getDay() !== 6) {
          addedDays++;
        }
      }
      return resultDate;
    };

    const firstDeliveryDate = addBusinessDays(currentDate, daysToAdd);
    const formattedDate = `${days[firstDeliveryDate.getDay()]}, ${firstDeliveryDate.getDate()} ${months[firstDeliveryDate.getMonth()]}`;
    $('.pdp-main__product-delivery .delivery_date').text(formattedDate);
  }

  // ------------------------ Tabs -----------------------------------
  function Tabs() {
    const $tabs = $('.pdp-tabs'),
      $headers = $tabs.find('.pdp-tabs__header-item'),
      $content = $tabs.find('.pdp-tabs__content-item');

    // Initialize with first header and first content active
    $headers.first().addClass('active');
    $content.first().addClass('active');

    $headers.on('click', function (e) {
      e.preventDefault();
      const tab = $(this).data('tab');
      $headers.removeClass('active').filter(`[data-tab="${tab}"]`).addClass('active');
      $content.removeClass('active').filter(`[data-tab="${tab}"]`).addClass('active');
    });
  }
  Tabs();



  // ------------------------ Popup Upsell Timer -----------------------------------
  function PopupUpsellTimer() {
    const popup = $('.popup-upsell'),
      popup_timer = popup.find('.popup-upsell__timer');

    if (!popup_timer.length) return { start: () => { }, stop: () => { } };

    const timer = popup_timer.find('.countdown');
    let time = parseInt(popup_timer.data('timer'), 10) * 60,
      timerInterval;

    const formatTime = t => [Math.floor(t / 3600), Math.floor((t % 3600) / 60), t % 60]
      .map(v => v.toString().padStart(2, '0')).join(':');

    const update = () => {
      if (time < 0) {
        clearInterval(timerInterval);
        popup.removeClass('active').find('.popup-upsell__decline').trigger('click');
        return;
      }
      timer.text(formatTime(time--));
    };

    popup.on('click', e => {
      if ($(e.target).hasClass('modal-overlay')) {
        popup.removeClass('active');
        clearInterval(timerInterval);
        popup.find('.popup-upsell__decline').trigger('click');
      }
    });

    return {
      start: () => { time = parseInt(popup_timer.data('timer'), 10) * 60; update(); timerInterval = setInterval(update, 1000); },
      stop: () => timerInterval && clearInterval(timerInterval)
    };
  }

  calculateDeliveryDate(5);


  // Initialize popup upsell timer
  window.popupUpsellTimer = PopupUpsellTimer();

});